import React from 'react';
import { useStyles } from 'features/auth/components/Login/styles';
import { useTranslation } from 'hooks/useTranslation';
import useAuth from 'features/auth/hooks/useAuth';
import { useValidation } from 'hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { AuthInputField } from 'features/auth/components/AuthInputField';
import { Box, Link, Typography } from '@material-ui/core';
import { Buttons } from 'shared';

const LoginVerificationCode = ({ onResendCode }: { onResendCode: () => void }) => {
  const classes = useStyles();
  const { t } = useTranslation('auth');
  const { onEnterVerificationCode, isLoading } = useAuth();
  const { required } = useValidation();

  const form = useForm<{ token: string }>({
    mode: 'onSubmit',
    defaultValues: { token: '' },
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = form;

  const onSubmit = ({ token }: { token: string }) => {
    onEnterVerificationCode(token);
  };

  const handleResentCode = (e: React.MouseEvent) => {
    e.preventDefault();
    onResendCode();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display="flex"
          flexDirection="column"
          className={`${classes.loginFormContent} ${classes.verifyCodeFormContent}`}
        >
          <AuthInputField
            autoFocus
            required
            name="token"
            control={control}
            fullWidth
            placeholder={'XXXXXX'}
            label={t('verificationCodeNotation')}
            className={classes.emailInputField}
            autoComplete={'off'}
            rules={{
              validate: {
                ...required,
              },
            }}
          />
          <Typography className={classes.resetCode}>
            <Link className={classes.resetCodeLink} href={'/reset-password'} onClick={handleResentCode}>
              {t('resendCode', { ns: 'common' })}
            </Link>
          </Typography>
        </Box>

        <Box className={classes.loginButtonWrapper}>
          <Buttons.Auth
            fullWidth
            disabled={isSubmitting}
            title={t('submit', { ns: 'common' })}
            variant="outlined"
            color="primary"
            loading={isLoading}
            classes={{ label: classes.loginBtnLabel, root: classes.loginBtn }}
          />
        </Box>
      </form>
    </FormProvider>
  );
};

export default LoginVerificationCode;
